import {styled} from '@esgi/ui/theme';
import {FlexBox} from '@esgi/ui/layout';
import {SkeletonStyles} from '@esgi/ui/skeleton';

export const SkeletonList = styled(FlexBox, {
	...SkeletonStyles,
	minHeight: '48px',
});
